import { ofetch } from 'ofetch'

const SESSION_TOKEN_URL = '/auth/session-token'

let apiClient = null
let apiAuthenticatedClient = null

let mintPending = null

function createRecoveryFetch() {
  return async function recoveryFetch(request, options) {
    const response = await globalThis.fetch(request, options)

    const isMintCall = String(request).includes(SESSION_TOKEN_URL)

    if (response.status !== 401 || isMintCall) {
      return response
    }

    const recovered = await ensureFreshCredential()

    if (!recovered) {
      return response
    }

    return globalThis.fetch(request, options)
  }
}

function createMintFetch() {
  return async function mintFetch(request, options) {
    return globalThis.fetch(request, options)
  }
}

async function ensureFreshCredential() {
  if (!mintPending) {
    mintPending = getMintClient()(SESSION_TOKEN_URL)
      .then(() => true)
      .catch(() => false)
      .finally(() => {
        mintPending = null
      })
  }

  return mintPending
}

function createMintClient() {
  return ofetch.create({
    baseURL: window.location.origin,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-XSRF-TOKEN': decodeURIComponent(getCookie('XSRF-TOKEN') || ''),
    },
    retry: 0,
  }, { fetch: createMintFetch() })
}

let mintClient = null

function getMintClient() {
  if (!mintClient) {
    mintClient = createMintClient()
  }
  return mintClient
}

function createApiClient({ redirectOn401 = false } = {}) {
  return ofetch.create({
    baseURL: window.location.origin,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-XSRF-TOKEN': decodeURIComponent(getCookie('XSRF-TOKEN') || ''),
    },
    retry: 0,
    onResponseError({ response }) {
      const isOtpUnverified = response?.status === 403
        && response?._data?.status === 'otp-unverified'

      if (isOtpUnverified && window.location.pathname !== '/user/otp') {
        const otpUrl = new URL('/user/otp', window.location.origin)
        otpUrl.searchParams.set('redirect', getLoginReturnUrl())
        window.location.assign(otpUrl.toString())
        return
      }

      if (response.status === 401 && redirectOn401) {
        promptLoginRequired()
      }
    },
  }, { fetch: createRecoveryFetch() })
}

/** API client umum — 401 tidak redirect (guest-friendly). */
export function useApi() {
  if (!apiClient) {
    apiClient = createApiClient()
  }

  return apiClient
}

/** API client untuk endpoint wajib login — 401 tampilkan popup login. */
export function useApiAuthenticated() {
  if (!apiAuthenticatedClient) {
    apiAuthenticatedClient = createApiClient({ redirectOn401: true })
  }

  return apiAuthenticatedClient
}

export { ensureFreshCredential }

function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts.length === 2) {
    return parts.pop()?.split(';').shift()
  }

  return null
}
